import type { DesignSystemTooltipProps } from '@cmg/data-grid';
import { createValueFormatter, formatters } from '@cmg/data-grid';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import type {
  CalendarGridColDef,
  CalendarGridRowData,
  CalendarGridValueGetterFunc,
} from '../../CalendarGrid.model';
import { ManagersTooltipContent } from './ManagersTooltipContent';

export type Value = string[];
export type TooltipFieldValue = CalendarGridRowData['managers'];

export const valueFormatter = createValueFormatter<CalendarGridRowData, Value>({
  gridRow: ({ value }) => {
    return formatters.truncatedArrayValueFormatter(value ?? [], 2);
  },
});

export const valueGetter: CalendarGridValueGetterFunc<Value> = ({ data }) => {
  return data?.managers.map(manager => manager.name).filter((name): name is string => !!name) ?? [];
};

export const getTooltipContent: NonNullable<
  DesignSystemTooltipProps<CalendarGridRowData, TooltipFieldValue>['getContent']
> = ({ value }) => {
  if (!isNil(value) && !isEmpty(value)) {
    return () => <ManagersTooltipContent managers={value} />;
  }
};

const managersColDef: CalendarGridColDef<Value> = {
  colId: 'managers',
  headerName: 'Managers',
  tooltipField: 'managers',
  tooltipComponentParams: {
    getContent: getTooltipContent,
  },
  width: 218,
  filter: 'agSetColumnFilter',
  valueGetter,
  valueFormatter,
  useValueFormatterForExport: false,
};

export default managersColDef;
